{
  "name": "botframework-connector",
  "author": "Microsoft Corp.",
  "description": "Bot Connector is autorest generated connector client.",
  "version": "4.1.6",
  "license": "MIT",
  "keywords": [
    "botconnector",
    "bots",
    "chatbots"
  ],
  "bugs": {
    "url": "https://github.com/Microsoft/botbuilder-js/issues"
  },
  "repository": {
    "type": "git",
    "url": "https://github.com/Microsoft/botbuilder-js.git"
  },
  "main": "lib/index.js",
  "browser": "lib/browser.js",
  "types": "lib/index.d.ts",
  "typesVersions": {
    "<3.9": {
      "*": [
        "_ts3.4/*"
      ]
    }
  },
  "dependencies": {
    "@azure/core-http": "^3.0.4",
    "@azure/identity": "^4.4.1",
    "@azure/msal-node": "^2.13.1",
    "@types/jsonwebtoken": "9.0.6",
    "axios": "^1.7.7",
    "base64url": "^3.0.0",
    "botbuilder-stdlib": "4.1.6",
    "botframework-schema": "4.1.6",
    "buffer": "^6.0.3",
    "cross-fetch": "^4.0.0",
    "https-proxy-agent": "^7.0.5",
    "jsonwebtoken": "^9.0.2",
    "node-fetch": "^2.7.0",
    "openssl-wrapper": "^0.3.4",
    "rsa-pem-from-mod-exp": "^0.8.6",
    "zod": "^3.23.8"
  },
  "devDependencies": {
    "@types/node": "18.19.47",
    "botbuilder-test-utils": "0.0.0",
    "dotenv": "^16.4.5",
    "nock": "^13.5.5",
    "should": "^13.2.3",
    "uuid": "^11.0.5"
  },
  "scripts": {
    "build": "tsc -b",
    "build:browser": "npm-run-all build:browser:clean build:browser:run",
    "build:browser:clean": "rimraf --glob lib/browser.*",
    "build:browser:run": "tsup --config ../../tsup/browser.config.ts",
    "build:downlevel-dts": "downlevel-dts lib _ts3.4/lib --checksum",
    "clean": "rimraf _ts3.4 lib tsconfig.tsbuildinfo",
    "depcheck": "depcheck --config ../../.depcheckrc --ignores azure,sinon,browserify-fs,buffer,crypto-browserify,https-browserify,stream-browserify,stream-http",
    "lint": "eslint .",
    "postbuild": "npm-run-all -p build:browser build:downlevel-dts",
    "test": "yarn build && yarn test:mocha",
    "test:mocha": "nyc mocha tests --recursive"
  },
  "files": [
    "_ts3.4",
    "lib",
    "src"
  ]
}
